import planetMercury from './planet-mercury.svg';
import planetMercuryInternal from './planet-mercury-internal.svg';
import planetMercuryGeology from './geology-mercury.png';
import planetVenus from './planet-venus.svg';
import planetVenusInternal from './planet-venus-internal.svg';
import planetVenusGeology from './geology-venus.png';
import planetEarth from './planet-earth.svg';
import planetEarthInternal from './planet-earth-internal.svg';
import planetEarthGeology from './geology-earth.png';
import planetMars from './planet-mars.svg';
import planetMarsInternal from './planet-mars-internal.svg';
import planetMarsGeology from './geology-mars.png';
import planetJupiter from './planet-jupiter.svg';
import planetJupiterInternal from './planet-jupiter-internal.svg';
import planetJupiterGeology from './geology-jupiter.png';
import planetSaturn from './planet-saturn.svg';
import planetSaturnInternal from './planet-saturn-internal.svg';
import planetSaturnGeology from './geology-saturn.png';
import planetUranus from './planet-uranus.svg';
import planetUranusInternal from './planet-uranus-internal.svg';
import planetUranusGeology from './geology-uranus.png';
import planetNeptune from './planet-neptune.svg';
import planetNeptuneInternal from './planet-neptune-internal.svg';
import planetNeptuneGeology from './geology-neptune.png';
import iconSource from './icon-source.svg';
import iconHamburger from './icon-hamburger.svg';
import iconChevron from './icon-chevron.svg';

export const images: any = {
  planetMercury,
  planetMercuryInternal,
  planetMercuryGeology,
  planetVenus,
  planetVenusInternal,
  planetVenusGeology,
  planetEarth,
  planetEarthInternal,
  planetEarthGeology,
  planetMars,
  planetMarsInternal,
  planetMarsGeology,
  planetJupiter,
  planetJupiterInternal,
  planetJupiterGeology,
  planetSaturn,
  planetSaturnInternal,
  planetSaturnGeology,
  planetUranus,
  planetUranusInternal,
  planetUranusGeology,
  planetNeptune,
  planetNeptuneInternal,
  planetNeptuneGeology,
  iconSource,
  iconHamburger,
  iconChevron,
};
